const reciboSimplesFormSchema = [
  {
    sectionId: "dados-pagador",
    sectionLabel: "Pagador",
    fields: [
      {
        id: "NOME_PESSOA_FISICA",
        label: "Nome do pagador",
        type: "text",
        required: true,
      },
      {
        id: "TIPO_DOCUMENTO_PAGADOR",
        label: "Tipo de documento",
        type: "radio",
        required: true,
        default: "cpf",
        options: [
          { label: "CPF", value: "cpf" },
          { label: "CNPJ", value: "cnpj" },
        ],
      },
      {
        id: "CPF_CNPJ_PAGADOR",
        label: "CPF/CNPJ do pagador",
        type: "text",
        required: true,
        maskDependsOn: "TIPO_DOCUMENTO_PAGADOR",
        maskByValue: { cpf: "cpf", cnpj: "cnpj" },
      },
    ],
  },
  {
    sectionId: "dados-recibo",
    sectionLabel: "Valor e referência",
    fields: [
      {
        id: "VALOR",
        label: "Valor (R$)",
        type: "text",
        mask: "brl_currency",
        required: true,
      },
      {
        id: "VALOR_EXTENSO",
        label: "Valor por extenso",
        type: "text",
        required: true,
        extensoOf: "VALOR",
      },
      {
        id: "REFERENTE",
        label: "Referente a",
        type: "text",
        required: true,
      },
      {
        id: "FORMA_PAGAMENTO",
        label: "Forma de pagamento",
        type: "text",
        required: true,
      },
    ],
  },
  {
    sectionId: "recebedor",
    sectionLabel: "Recebedor",
    fields: [
      {
        id: "NOME_RECEBEDOR",
        label: "Nome do recebedor",
        type: "text",
        required: true,
      },
      {
        id: "TIPO_DOCUMENTO_RECEBEDOR",
        label: "Tipo de documento",
        type: "radio",
        required: true,
        default: "cpf",
        options: [
          { label: "CPF", value: "cpf" },
          { label: "CNPJ", value: "cnpj" },
        ],
      },
      {
        id: "CPF_CNPJ_RECEBEDOR",
        label: "CPF/CNPJ do recebedor",
        type: "text",
        required: true,
        maskDependsOn: "TIPO_DOCUMENTO_RECEBEDOR",
        maskByValue: { cpf: "cpf", cnpj: "cnpj" },
      },
    ],
  },
  {
    sectionId: "dados-assinatura",
    sectionLabel: "Local e data",
    fields: [
      {
        id: "CIDADE",
        label: "Cidade",
        type: "text",
        required: true,
      },
      {
        id: "DATA",
        label: "Data",
        type: "date",
        required: true,
      },
    ],
  },
];

export default reciboSimplesFormSchema;
